import { displayResourcesAtom } from "@app/resources/atom";
import { ResourcesGrid } from "@app/resources/components/ResourcesGrid";
import { ResourcesList } from "@app/resources/components/ResourcesList";
import { type Resource } from "@core/shared/types";
import { cn } from "@design-system/utils";
import { trans } from "@mongez/localization";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

type ResourcesSectionProps = {
  groupedResources: Record<string, Resource[]>;
  className?: string;
};

export function ResourcesSection({
  groupedResources,
  className,
}: ResourcesSectionProps) {
  const categories = Object.keys(groupedResources);

  const displayResources = displayResourcesAtom.useValue();

  if (categories.length === 0) {
    return (
      <div className={cn("py-12 text-center", className)}>
        <div className="mx-auto max-w-md">
          <div className="mx-auto mb-6 w-fit rounded-full bg-gradient-to-br from-blue-50 to-indigo-100 p-6 dark:from-blue-900/20 dark:to-indigo-900/20">
            <svg
              className="h-12 w-12 text-blue-400 dark:text-blue-300"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              />
            </svg>
          </div>
          <h3 className="mb-2 text-xl font-semibold text-gray-700 dark:text-gray-100">
            {trans("grades.noResourcesAvailable")}
          </h3>
          <p className="text-gray-500 dark:text-gray-400">
            لا توجد موارد متاحة حالياً
          </p>
        </div>
      </div>
    );
  }

  return (
    <>
      {displayResources === "grid" ? (
        <ResourcesGrid groupedResources={groupedResources} />
      ) : (
        <ResourcesList groupedResources={groupedResources} />
      )}
    </>
  );
}
